module.exports = __webpack_public_path__ + "static/images/logo-wef.06c114d8427c5b863a35186fab08f68b.png";